export {default as insightReportLogo} from './logo.png';
